/**
 * @fileoverview Google Group menu controller for the matching step of the Listings Launch flow.
 *
 * @author Stephanie Yoon (steyoon@yext.com)
 */

import {SubHeader} from '/src/com/yext/listingslaunchstorm/js/components/common/subheader';
import {GoogleGroup} from '/src/com/yext/listingslaunchstorm/js/data/googlegroup';
import {ContentSkeleton} from '/ui/components/contentskeleton/contentskeleton';
import {MenuController} from '/ui/components/menu/menucontroller';

import * as styles from '/src/com/yext/listingslaunchstorm/js/components/styles/groupmenucontroller.module.scss';

/**
 * Google Group menu controller for the matching step of the Listings Launch flow.
 * @param {{
 *  loadingGroups: boolean,
 *  googleGroups: Array<GoogleGroup>,
 *  selected: string,
 *  onSelect: function(GoogleGroup, string)
 * }} props
 * @return {React.ReactNode}
*/
export const GroupMenuController = ({loadingGroups,
  googleGroups,
  selected,
  onSelect}) => {
  if (loadingGroups) {
    return <ContentSkeleton />;
  }

  if (googleGroups.length === 0) {
    return <div />;
  }

  const actions = googleGroups.map(group => {
    const displayedGoogleGroup = group.name + ' (' + group.id + ')';
    return {
      name: displayedGoogleGroup,
      callback: () => onSelect(group, displayedGoogleGroup),
    };
  });

  return (
    <div>
      <SubHeader
        mainText={yext.msg('Location Group')}
        extraText={yext.msg('Please find your Location Group in your Google Business Profile account')}
      />
      <div className={styles.controller}>
        <MenuController
          enableSearch
          pendoId="listings-launch-flow-matching-select-group-business-id"
          actions={actions}
          label={selected === null ? yext.msg('Select Location Group') : selected}
          // TODO: remove or update after Aurora adds mobile support for this component
          wrapperClassName={styles.menuController}
        />
      </div>
    </div>
  );
};
